import { gql, MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'

interface Data {
  status: {
    message: string
  }
}

interface Variables {
  email: string
  redirect: string
  verifyWithPassword?: boolean
}

const MUTATION = gql`
  mutation requestEmailToken($email: String!, $redirect: String!, $verifyWithPassword: Boolean) {
    status: requestEmailToken(email: $email, redirect: $redirect, verifyWithPassword: $verifyWithPassword) {
      message
    }
  }
`

export const useLoginByEmailMutation = (
  options?: MutationHookOptions<Data, Variables>,
): MutationTuple<Data, Variables> => useMutation<Data, Variables>(MUTATION, options)
